if (!customElements.get("product-gallery-view-toggle")) {
  class ProductGalleryViewToggle extends HTMLElement {
    connectedCallback() {
      this._input = this.querySelector('input[type="checkbox"]');
      this._root = this.closest("product-gallery");
      this._btnLeft = this.querySelector('[data-gallery-segment="default"]');
      this._btnRight = this.querySelector('[data-gallery-segment="alternate"]');
      if (!this._input || !this._root) {
        return;
      }
      this._btnLeft?.addEventListener("click", (event) => {
        event.preventDefault();
        if (this._input.checked) {
          this._input.checked = false;
          this._input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
      this._btnRight?.addEventListener("click", (event) => {
        event.preventDefault();
        if (!this._input.checked) {
          this._input.checked = true;
          this._input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
      this._input.addEventListener("change", () => this._sync());
      this._sync();
    }

    _sync() {
      const showAlternate = this._input.checked;
      this._root.querySelectorAll('[data-gallery-view="default"]').forEach((el) => el.toggleAttribute("hidden", showAlternate));
      this._root.querySelectorAll('[data-gallery-view="alternate"]').forEach((el) => el.toggleAttribute("hidden", !showAlternate));
      this.classList.toggle("is-alternate", showAlternate);
      this._btnLeft?.setAttribute("aria-pressed", String(!showAlternate));
      this._btnRight?.setAttribute("aria-pressed", String(showAlternate));
    }
  }
  customElements.define("product-gallery-view-toggle", ProductGalleryViewToggle);
}
